import { useEffect } from "react";
import { api } from "../lib/api";

function hexToHsl(hex) {
  if (!hex) return null;
  const m = hex.replace("#", "");
  const r = parseInt(m.substring(0, 2), 16) / 255;
  const g = parseInt(m.substring(2, 4), 16) / 255;
  const b = parseInt(m.substring(4, 6), 16) / 255;
  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  let h = 0, s = 0;
  const l = (max + min) / 2;
  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r: h = (g - b) / d + (g < b ? 6 : 0); break;
      case g: h = (b - r) / d + 2; break;
      case b: h = (r - g) / d + 4; break;
      default: break;
    }
    h /= 6;
  }
  return [Math.round(h * 360), Math.round(s * 100), Math.round(l * 100)];
}

export default function ThemeProvider({ children }) {
  useEffect(() => {
    api.get("/theme").then(({ data }) => {
      const root = document.documentElement;
      const map = {
        "--c-bg-deep": data.bg_deep,
        "--c-bg-forest": data.bg_forest,
        "--c-moss": data.moss,
        "--c-bio-green": data.bio_green,
        "--c-firefly-gold": data.firefly_gold,
        "--c-firefly-pale": data.firefly_pale,
        "--c-mist": data.mist,
        "--c-text": data.text_primary,
        "--font-serif": `'${data.font_serif}', Georgia, serif`,
        "--font-sans": `'${data.font_sans}', system-ui, sans-serif`,
        "--font-fairy": `'${data.font_fairy}', cursive`,
      };
      Object.entries(map).forEach(([k, v]) => v && root.style.setProperty(k, v));

      const hsl = hexToHsl(data.bg_deep);
      if (hsl) root.style.setProperty("--background", `${hsl[0]} ${hsl[1]}% ${hsl[2]}%`);
      const fg = hexToHsl(data.text_primary);
      if (fg) root.style.setProperty("--foreground", `${fg[0]} ${fg[1]}% ${fg[2]}%`);
      const accent = hexToHsl(data.firefly_gold);
      if (accent) root.style.setProperty("--accent", `${accent[0]} ${accent[1]}% ${accent[2]}%`);
      const prim = hexToHsl(data.bio_green);
      if (prim) root.style.setProperty("--primary", `${prim[0]} ${prim[1]}% ${prim[2]}%`);
    }).catch(() => {});
  }, []);
  return children;
}
